import { AppHttpClient } from 'common/core/http/app-http-client.service';
import { FOLDERS_API_ROUTES } from './folders-api-routes.enum';
import { CurrentUser } from 'common/auth/current-user';
import * as i0 from "@angular/core";
import * as i1 from "../../../../common/core/http/app-http-client.service";
import * as i2 from "../../../../common/auth/current-user";
var FoldersApiService = /** @class */ (function () {
    function FoldersApiService(http, currentUser) {
        this.http = http;
        this.currentUser = currentUser;
    }
    FoldersApiService.prototype.getAll = function (params) {
        return this.http.get(FOLDERS_API_ROUTES.GET_ALL, params);
    };
    FoldersApiService.prototype.getAllForCurrentUser = function () {
        return this.http.get('drive/users/' + this.currentUser.get('id') + '/folders');
    };
    FoldersApiService.prototype.create = function (params) {
        if (params.parent_id === 'root')
            params.parent_id = null;
        return this.http.post(FOLDERS_API_ROUTES.CREATE, params);
    };
    FoldersApiService.prototype.getByHash = function (hash) {
        return this.http.get('drive/folders/find', { hash: hash });
    };
    FoldersApiService.ngInjectableDef = i0.defineInjectable({ factory: function FoldersApiService_Factory() { return new FoldersApiService(i0.inject(i1.AppHttpClient), i0.inject(i2.CurrentUser)); }, token: FoldersApiService, providedIn: "root" });
    return FoldersApiService;
}());
export { FoldersApiService };
